import { basename } from "./path";

export function downloadFile(name: string, url: string) {
  const link = document.createElement("a");
  link.download = basename(name);
  link.href = url;
  link.click();
}
